import { obsidianImg } from "../images/images";
import {
  bootstrapTexture,
  cssTexture,
  dockerTexture,
  expressTexture,
  flaskTexture,
  gitTexture,
  githubTexture,
  htmlTexture,
  javaTexture,
  jsTexture,
  linuxTexture,
  mongoDBTexture,
  nextTexture,
  nodeJSTexture,
  pythonTexture,
  reactTexture,
  redisTexture,
  sqlTexture,
  tailwindTexture,
  figmaTexture,
  teamcityTexture,
  seleniumTexture,
  jiraTexture,
} from "../images/skillTextures";
import {
  bootstrapLogo,
  cssLogo,
  dockerLogo,
  expressLogo,
  flaskLogo,
  gitLogo,
  githubLogo,
  htmlLogo,
  javaLogo,
  jsLogo,
  linuxLogo,
  mongoDBLogo,
  nextLogo,
  nodeJSLogo,
  pythonLogo,
  reactLogo,
  redisLogo,
  sqlLogo,
  tailwindLogo,
  figmaLogo,
  teamcityLogo,
  seleniumLogo,
  jiraLogo,
} from "../images/skillsLogo";
import { obsidianTexture } from "../images/textures";
import {
  stonePlace1,
  stonePlace2,
  stonePlace3,
  stonePlace4,
} from "../sounds/sounds";

export const skillBlocks = {
  react: {
    placed: [stonePlace1, stonePlace2, stonePlace3, stonePlace4],
    breaks: [stonePlace1, stonePlace2, stonePlace3, stonePlace4],
    right: reactTexture,
    left: reactTexture,
    top: reactTexture,
    bottom: reactTexture,
    front: reactTexture,
    back: reactTexture,
    image: reactLogo,
    rotational: false,
  },
  next_js: {
    placed: [stonePlace1, stonePlace2, stonePlace3, stonePlace4],
    breaks: [stonePlace1, stonePlace2, stonePlace3, stonePlace4],
    right: nextTexture,
    left: nextTexture,
    top: nextTexture,
    bottom: nextTexture,
    front: nextTexture,
    back: nextTexture,
    image: nextLogo,
    rotational: false,
  },
  mongo_db: {
    placed: [stonePlace1, stonePlace2, stonePlace3, stonePlace4],
    breaks: [stonePlace1, stonePlace2, stonePlace3, stonePlace4],
    right: mongoDBTexture,
    left: mongoDBTexture,
    top: mongoDBTexture,
    bottom: mongoDBTexture,
    front: mongoDBTexture,
    back: mongoDBTexture,
    image: mongoDBLogo,
    rotational: false,
  },
  express: {
    placed: [stonePlace1, stonePlace2, stonePlace3, stonePlace4],
    breaks: [stonePlace1, stonePlace2, stonePlace3, stonePlace4],
    right: expressTexture,
    left: expressTexture,
    top: expressTexture,
    bottom: expressTexture,
    front: expressTexture,
    back: expressTexture,
    image: expressLogo,
    rotational: false,
  },
  node_js: {
    placed: [stonePlace1, stonePlace2, stonePlace3, stonePlace4],
    breaks: [stonePlace1, stonePlace2, stonePlace3, stonePlace4],
    right: nodeJSTexture,
    left: nodeJSTexture,
    top: nodeJSTexture,
    bottom: nodeJSTexture,
    front: nodeJSTexture,
    back: nodeJSTexture,
    image: nodeJSLogo,
    rotational: false,
  },
  bootstrap: {
    placed: [stonePlace1, stonePlace2, stonePlace3, stonePlace4],
    breaks: [stonePlace1, stonePlace2, stonePlace3, stonePlace4],
    right: bootstrapTexture,
    left: bootstrapTexture,
    top: bootstrapTexture,
    bottom: bootstrapTexture,
    front: bootstrapTexture,
    back: bootstrapTexture,
    image: bootstrapLogo,
    rotational: false,
  },
  tailwind: {
    placed: [stonePlace1, stonePlace2, stonePlace3, stonePlace4],
    breaks: [stonePlace1, stonePlace2, stonePlace3, stonePlace4],
    right: tailwindTexture,
    left: tailwindTexture,
    top: tailwindTexture,
    bottom: tailwindTexture,
    front: tailwindTexture,
    back: tailwindTexture,
    image: tailwindLogo,
    rotational: false,
  },
  git: {
    placed: [stonePlace1, stonePlace2, stonePlace3, stonePlace4],
    breaks: [stonePlace1, stonePlace2, stonePlace3, stonePlace4],
    right: gitTexture,
    left: gitTexture,
    top: gitTexture,
    bottom: gitTexture,
    front: gitTexture,
    back: gitTexture,
    image: gitLogo,
    rotational: false,
  },
  flask: {
    placed: [stonePlace1, stonePlace2, stonePlace3, stonePlace4],
    breaks: [stonePlace1, stonePlace2, stonePlace3, stonePlace4],
    right: flaskTexture,
    left: flaskTexture,
    top: flaskTexture,
    bottom: flaskTexture,
    front: flaskTexture,
    back: flaskTexture,
    image: flaskLogo,
    rotational: false,
  },
  python: {
    placed: [stonePlace1, stonePlace2, stonePlace3, stonePlace4],
    breaks: [stonePlace1, stonePlace2, stonePlace3, stonePlace4],
    right: pythonTexture,
    left: pythonTexture,
    top: pythonTexture,
    bottom: pythonTexture,
    front: pythonTexture,
    back: pythonTexture,
    image: pythonLogo,
    rotational: false,
  },
  java: {
    placed: [stonePlace1, stonePlace2, stonePlace3, stonePlace4],
    breaks: [stonePlace1, stonePlace2, stonePlace3, stonePlace4],
    right: javaTexture,
    left: javaTexture,
    top: javaTexture,
    bottom: javaTexture,
    front: javaTexture,
    back: javaTexture,
    image: javaLogo,
    rotational: false,
  },
  github: {
    placed: [stonePlace1, stonePlace2, stonePlace3, stonePlace4],
    breaks: [stonePlace1, stonePlace2, stonePlace3, stonePlace4],
    right: githubTexture,
    left: githubTexture,
    top: githubTexture,
    bottom: githubTexture,
    front: githubTexture,
    back: githubTexture,
    image: githubLogo,
    rotational: false,
  },
  docker: {
    placed: [stonePlace1, stonePlace2, stonePlace3, stonePlace4],
    breaks: [stonePlace1, stonePlace2, stonePlace3, stonePlace4],
    right: dockerTexture,
    left: dockerTexture,
    top: dockerTexture,
    bottom: dockerTexture,
    front: dockerTexture,
    back: dockerTexture,
    image: dockerLogo,
    rotational: false,
  },
  sql: {
    placed: [stonePlace1, stonePlace2, stonePlace3, stonePlace4],
    breaks: [stonePlace1, stonePlace2, stonePlace3, stonePlace4],
    right: sqlTexture,
    left: sqlTexture,
    top: sqlTexture,
    bottom: sqlTexture,
    front: sqlTexture,
    back: sqlTexture,
    image: sqlLogo,
    rotational: false,
  },
  html: {
    placed: [stonePlace1, stonePlace2, stonePlace3, stonePlace4],
    breaks: [stonePlace1, stonePlace2, stonePlace3, stonePlace4],
    right: htmlTexture,
    left: htmlTexture,
    top: htmlTexture,
    bottom: htmlTexture,
    front: htmlTexture,
    back: htmlTexture,
    image: htmlLogo,
    rotational: false,
  },
  css: {
    placed: [stonePlace1, stonePlace2, stonePlace3, stonePlace4],
    breaks: [stonePlace1, stonePlace2, stonePlace3, stonePlace4],
    right: cssTexture,
    left: cssTexture,
    top: cssTexture,
    bottom: cssTexture,
    front: cssTexture,
    back: cssTexture,
    image: cssLogo,
    rotational: false,
  },
  javascript: {
    placed: [stonePlace1, stonePlace2, stonePlace3, stonePlace4],
    breaks: [stonePlace1, stonePlace2, stonePlace3, stonePlace4],
    right: jsTexture,
    left: jsTexture,
    top: jsTexture,
    bottom: jsTexture,
    front: jsTexture,
    back: jsTexture,
    image: jsLogo,
    rotational: false,
  },

  linux: {
    placed: [stonePlace1, stonePlace2, stonePlace3, stonePlace4],
    breaks: [stonePlace1, stonePlace2, stonePlace3, stonePlace4],
    right: linuxTexture,
    left: linuxTexture,
    top: linuxTexture,
    bottom: linuxTexture,
    front: linuxTexture,
    back: linuxTexture,
    image: linuxLogo,
    rotational: false,
  },
  redis: {
    placed: [stonePlace1, stonePlace2, stonePlace3, stonePlace4],
    breaks: [stonePlace1, stonePlace2, stonePlace3, stonePlace4],
    right: redisTexture,
    left: redisTexture,
    top: redisTexture,
    bottom: redisTexture,
    front: redisTexture,
    back: redisTexture,
    image: redisLogo,
    rotational: false,
  },
  figma: {
    placed: [stonePlace1, stonePlace2, stonePlace3, stonePlace4],
    breaks: [stonePlace1, stonePlace2, stonePlace3, stonePlace4],
    right: figmaTexture,
    left: figmaTexture,
    top: figmaTexture,
    bottom: figmaTexture,
    front: figmaTexture,
    back: figmaTexture,
    image: figmaLogo,
    rotational: false,
  },
  teamcity: {
    placed: [stonePlace1, stonePlace2, stonePlace3, stonePlace4],
    breaks: [stonePlace1, stonePlace2, stonePlace3, stonePlace4],
    right: teamcityTexture,
    left: teamcityTexture,
    top: teamcityTexture,
    bottom: teamcityTexture,
    front: teamcityTexture,
    back: teamcityTexture,
    image: teamcityLogo,
    rotational: false,
  },
  selenium: {
    placed: [stonePlace1, stonePlace2, stonePlace3, stonePlace4],
    breaks: [stonePlace1, stonePlace2, stonePlace3, stonePlace4],
    right: seleniumTexture,
    left: seleniumTexture,
    top: seleniumTexture,
    bottom: seleniumTexture,
    front: seleniumTexture,
    back: seleniumTexture,
    image: seleniumLogo,
    rotational: false,
  },
  jira: {
    placed: [stonePlace1, stonePlace2, stonePlace3, stonePlace4],
    breaks: [stonePlace1, stonePlace2, stonePlace3, stonePlace4],
    right: jiraTexture,
    left: jiraTexture,
    top: jiraTexture,
    bottom: jiraTexture,
    front: jiraTexture,
    back: jiraTexture,
    image: jiraLogo,
    rotational: false,
  },

  obsidian: {
    placed: [stonePlace1, stonePlace2, stonePlace3, stonePlace4],
    breaks: [stonePlace1, stonePlace2, stonePlace3, stonePlace4],
    right: obsidianTexture,
    left: obsidianTexture,
    top: obsidianTexture,
    bottom: obsidianTexture,
    front: obsidianTexture,
    back: obsidianTexture,
    image: obsidianImg,
    rotational: false,
  },
};
